module.exports = __webpack_public_path__ + "img/cn-stu.863c7661.png";